import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { getMsalConfig } from './config/authConfig';
import LoginButton from './components/LoginButton';
import AuthCallback from './components/AuthCallback';
import UserProfile from './components/UserProfile';
import SimplifiedICPEvaluator from './components/SimplifiedICPEvaluator';
import ComplianceCoverage from './components/ComplianceCoverage';
import simplifiedIcpData from './data/simplified-icp-schema.json';

const msalInstance = new PublicClientApplication(getMsalConfig());

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/compliance" element={<ComplianceCoverage />} />
        <Route path="/auth/callback" element={
          <MsalProvider instance={msalInstance}>
            <AuthCallback />
          </MsalProvider>
        } />
        <Route path="*" element={
          <MsalProvider instance={msalInstance}>
            <div className="min-h-screen bg-gray-50">
              <AuthenticatedTemplate>
                <UserProfile />
                <SimplifiedICPEvaluator evaluationData={simplifiedIcpData} />
              </AuthenticatedTemplate>

              <UnauthenticatedTemplate>
                <LoginButton />
              </UnauthenticatedTemplate>
            </div>
          </MsalProvider>
        } />
      </Routes>
    </Router>
  );
}

export default App;
